module.exports = __webpack_public_path__ + "static/media/check.51274286.gif";